import { useEffect } from "react";
import { MainLayout } from "@/components/MainLayout";
import { MilestonesPage } from "@/components/construction/MilestonesPage";

/**
 * Measurements (Medições) Page for Construction
 *
 * NEW FEATURE: Milestone-based payment tracking
 *
 * This page implements a milestone payment system for construction works,
 * allowing construction companies to:
 * - Define payment stages (e.g., 30% upfront, 30% mid, 40% completion)
 * - Track which milestones have been paid
 * - Link milestone payments to specific works (cost centers)
 *
 * Implementation Approach (MVP):
 * - Uses existing transaction installment fields
 * - Creates one income transaction per milestone schedule
 * - total_installments = number of milestones
 * - current_installment tracks progress
 * - notes field contains milestone breakdown
 *
 * This approach reuses existing UI components and database schema,
 * while providing construction-specific functionality.
 */
export default function MeasurementsPage() {
  useEffect(() => {
    document.title = "Medições | Controle Financeiro";
  }, []);

  return (
    <MainLayout>
      <div className="container mx-auto py-6">
        <MilestonesPage />
      </div>
    </MainLayout>
  );
}
